const routerArr = [
    {
        path: '/rank',
        name: 'rank',
        meta: {
            title:'排行榜',
            login:true
        },
        component: () => import(/* webpackChunkName: 'rank' */ './index.vue'),
    }
  ];
  export default routerArr;